import React, {useEffect, useState} from 'react'

type Props = {
 open: boolean
 title?: string
 placeholder?: string
 submitText?: string
 onClose: () => void
 onSubmit: (comment: string) => Promise<void>
 label?: string
}

const ReasonModal: React.FC<Props> = ({
 open,
 title = 'Reason for Not Satisfied',
 placeholder = 'Enter comment',
 submitText = 'Submit',
 label = 'Comment',
 onClose,
 onSubmit,
}) => {
 const [comment, setComment] = useState('')

 useEffect(() => {
  if (!open) {
   setComment('')
  }
 }, [open])

 if (!open) return null

 const handleSubmit = () => {
  if (!comment.trim()) return
  void onSubmit(comment)
  setComment('')
 }

 return (
  <div className='fixed inset-0 z-50 flex items-center justify-center'>
   <div
    className='absolute inset-0 bg-black bg-opacity-40'
    onClick={onClose}
   />

   <div className='relative bg-white w-[500px] rounded-3xl shadow-xl p-8 z-10'>
    <button
     onClick={onClose}
     className='absolute top-5 right-5 bg-gray-200 w-10 h-10 rounded-full flex items-center justify-center text-gray-600 hover:bg-gray-300'
    >
     ✕
    </button>

    <h2 className='text-2xl font-semibold mb-6'>{title}</h2>

    <div className='mb-6'>
     <div className='relative'>
      <span className='absolute top-1 left-3 bg-white px-1 text-sm text-blue-600'>
       {label}
      </span>

      <textarea
       value={comment}
       onChange={(e) => setComment(e.target.value)}
       placeholder={placeholder}
       className='w-full h-36 border border-[#E6EBF0] rounded-2xl p-4 pt-7
                 focus:outline-none focus:ring-2 focus:ring-blue-400'
      />
     </div>
    </div>

    <button
     onClick={() => {
      if (comment.trim()) handleSubmit()
     }}
     className={`w-full py-3 rounded-xl font-medium transition 
            ${
             comment.trim()
              ? 'bg-[#4E83E4] text-white hover:bg-gray-900'
              : 'bg-[#F2F2F2] text-gray-400 cursor-not-allowed'
            }`}
    >
     {submitText}
    </button>
   </div>
  </div>
 )
}

export default ReasonModal
